export default __webpack_public_path__ + "static/media/digit_span_male_3.6512a335.png";